import SortDescIcon from '@material-ui/icons/ArrowDropDown';
import SortAscIcon from '@material-ui/icons/ArrowDropUp';
import SortNoneIcon from '@material-ui/icons/UnfoldMore';
import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { SortDirection } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { BaseTableRow, SortState, TableColumn } from './types';

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const StyledIconButton = styled(IconButton)`
  flex-grow: 0;
  flex-shrink: 0;
  height: 28px;
  padding-right: 6px;
  padding-left: 6px;
  margin-top: -4px;
  margin-bottom: -4px;
`;

type SortIconProps = {
  sortDirection?: SortDirection;
};

function SortIcon({ sortDirection }: SortIconProps) {
  if (sortDirection === SortDirection.DESC) {
    return <SortDescIcon style={{ fontSize: '1rem' }} />;
  }
  if (sortDirection === SortDirection.ASC) {
    return <SortAscIcon style={{ fontSize: '1rem' }} />;
  }
  return <SortNoneIcon style={{ fontSize: '1rem' }} />;
}

type HeaderLabelWithSortingProps<RowEntity extends BaseTableRow> = {
  column: TableColumn<RowEntity>;
  onSortByColumn: (column: TableColumn<RowEntity>) => void;
  sortState?: SortState;
};

export function HeaderLabelWithSorting<RowEntity extends BaseTableRow>({
  column,
  onSortByColumn,
  sortState,
}: HeaderLabelWithSortingProps<RowEntity>) {
  return (
    <LabelContainer>
      {column.header}
      <StyledIconButton onClick={() => onSortByColumn(column)}>
        <VisuallyHidden>Sort {column.sortAriaHeader} column</VisuallyHidden>
        <SortIcon
          sortDirection={
            column.id === sortState?.columnId ? sortState?.direction : undefined
          }
        />
      </StyledIconButton>
    </LabelContainer>
  );
}
